import { useEffect, useState } from 'react'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { cn } from '@/lib/utils'

type Phase = 'idle' | 'loading' | 'completing'

export function GlobalFetchingBar() {
  const isFetching = useIsFetching() > 0
  const isMutating = useIsMutating() > 0
  const isActive = isFetching || isMutating
  const [phase, setPhase] = useState<Phase>('idle')

  useEffect(() => {
    if (isActive) {
      const timer = window.setTimeout(() => setPhase('loading'), 0)
      return () => window.clearTimeout(timer)
    }

    if (phase !== 'loading') return

    const completeTimer = window.setTimeout(() => setPhase('completing'), 0)
    const idleTimer = window.setTimeout(() => setPhase('idle'), 400)
    return () => {
      window.clearTimeout(completeTimer)
      window.clearTimeout(idleTimer)
    }
  }, [isActive, phase])

  if (phase === 'idle') return null

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-0.5 overflow-hidden">
      <div
        className={cn(
          'relative h-full overflow-hidden bg-primary shadow-[0_0_8px_var(--color-primary)] transition-all ease-out',
          phase === 'loading' ? 'global-fetching-bar w-4/5 opacity-100 duration-700' : 'w-full opacity-0 duration-300'
        )}
      />
    </div>
  )
}
